export default __webpack_public_path__ + "static/media/1998.fe32dcdb.png";